var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeOpenTextDuotone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fad",
    "data-icon": "envelope-open-text",
    className: "svg-inline--fa fa-envelope-open-text fa-w-16",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fa-group"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fa-secondary",
    fill: "#ccc",
    d: "M448 96v161.62L284.12 376a47.89 47.89 0 0 1-56.21 0L64 257.62V96a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "fa-primary",
    fill: "#ccc",
    d: "M336 224H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm16-64a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16zM329.41 41.44C312.6 29.18 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44L152 64h208zM64 129c-23.88 17.69-42.67 31.65-45.61 34A48 48 0 0 0 0 200.72v10.65l64 46.24zm429.61 34c-2.94-2.3-21.73-16.26-45.61-33.93v128.54l64-46.24v-10.65A48 48 0 0 0 493.61 163zM256 417.13a79.83 79.83 0 0 1-46.86-15.19L0 250.86V464a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V250.86L302.86 401.94A80 80 0 0 1 256 417.13z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpenTextDuotone);
export default __webpack_public_path__ + "static/media/envelope-open-text-duotone.9f0047792e245fe505057022365f89b1.svg";
export { ForwardRef as ReactComponent };